// extracted by mini-css-extract-plugin
module.exports = {"list":"RebatesSection_list__fyTTg","listItem":"RebatesSection_listItem__PKm7R"};